import { lazy } from 'react';
import type { AppRoute } from 'src/shared/routes';

const SchedulePage = lazy(() => import('./SchedulePage'));

export const scheduleRoutes: AppRoute[] = [
  { path: '/horario', name: 'Horario', element: SchedulePage },
];
